/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import smallPlus from '../../assets/images/model/small_plus.svg';
const AddOptions = ({ selectedOption, setSelectedOption, setIsEditing, addOption }) => {
  const handleDropdownSelect = (type) => {
    setSelectedOption(type); // Update selected option state
  };

  return (
    <div className='option-adder-wrapper'>
      <div className='Multiplechoice_wrap add_text_save'>
        <div className='btn-group' style={{ alignItems: 'center' }}>
          <img
            src={smallPlus}
            alt='plus'
            className='mr-3 cursor'
            onClick={() => {
              addOption(null);
            }}
            style={{ paddingRight: '5px' }}
          />
          Add
          <button
            type='button'
            className='btn btn-link dropdown-toggle'
            data-bs-toggle='dropdown'
            aria-expanded='false'
            style={{ margin: '0 4px' }}
          >
            {selectedOption || 'option'}
          </button>
          option
          <ul className='dropdown-menu cursor'>
            {1 && (
              <li>
                <a
                  className='dropdown-item cursor'
                  onClick={() => {
                    handleDropdownSelect('text');
                    addOption('text');
                  }}
                >
                  text
                </a>
              </li>
            )}
            {1 && (
              <li>
                <a
                  className='dropdown-item cursor'
                  onClick={() => {
                    handleDropdownSelect('image');
                    addOption('image');
                  }}
                >
                  image
                </a>
              </li>
            )}
            {1 && (
              <li>
                <a
                  className='dropdown-item cursor'
                  onClick={() => {
                    handleDropdownSelect('audio');
                    addOption('audio');
                  }}
                >
                  audio
                </a>
              </li>
            )}
            {1 && (
              <li>
                <a
                  className='dropdown-item cursor'
                  onClick={() => {
                    handleDropdownSelect('video');
                    addOption('video');
                  }}
                >
                  video
                </a>
              </li>
            )}
          </ul>
        </div>
        <div
          className='saved_button'
          onClick={() => {
            setIsEditing((old) => !old);
          }}
        >
          Save --{'>'}
        </div>
      </div>
    </div>
  );
};

export default AddOptions;
